import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAdmin } from '@/contexts/AdminContext';
import { ShieldAlert } from 'lucide-react';

/**
 * Componente per proteggere le pagine che richiedono solo accesso admin (non tecnico)
 */
const AdminOnlyGuard = ({ children }) => {
  const { isAdmin, role, loading } = useAdmin();

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Non autenticato
  if (!isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  // Tecnico che tenta di accedere a pagine admin-only
  if (role === 'tech') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center bg-white p-8 rounded-xl shadow-lg max-w-md">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
            <ShieldAlert className="text-red-600" size={32} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Accesso Non Autorizzato</h2>
          <p className="text-gray-600 mb-6">Il tuo account tecnico non ha accesso a questa sezione.</p>
          <Link 
            to="/admin/statistics" 
            className="bg-emerald-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors inline-block"
          >
            Vai alle Statistiche
          </Link>
        </div>
      </div>
    );
  }

  // Admin con accesso completo
  return children;
};

export default AdminOnlyGuard;
